/**
 * SPAC warrant / right LMV/RC limit. Warrants (WT) and rights (RT) are checked
 * against their own limit (default 2.18% of the SPAC risk capital, admin-
 * configurable), or - when the user flips the toggle - against the PM approval
 * level computed by the backend from the day's AUM.
 */

export const WT_RT_CODES = ["WT", "RT"];

export const isWarrantOrRight = (investmentTypeCode) => WT_RT_CODES.includes(investmentTypeCode);

export const WT_RT_LIMIT_SOURCE = { STANDARD: "standard", PM_APPROVAL: "pm_approval" };

const finite = (v) => (v == null || v === "" || !Number.isFinite(Number(v)) ? null : Number(v));

/**
 * The LMV/RC limit (percent) to compare a warrant/right against, and its label.
 * Falls back to the standard limit when the PM approval level was requested but
 * isn't available (no ratios configured / no AUM or risk capital).
 */
export function resolveWtRtLimit({ source, wtRtLimitPct, pmApprovalLevelPct }) {
  const standard = finite(wtRtLimitPct);
  const pm = finite(pmApprovalLevelPct);
  if (source === WT_RT_LIMIT_SOURCE.PM_APPROVAL && pm != null) {
    return { pct: pm, source: WT_RT_LIMIT_SOURCE.PM_APPROVAL, label: "PM approval level" };
  }
  return { pct: standard, source: WT_RT_LIMIT_SOURCE.STANDARD, label: "WT/RT limit" };
}

/**
 * PM approval levels for the admin preview: (ratio% x AUM) / Allocated SPAC
 * Risk Capital, as a percent. Mirrors riskLimitsService.computePmApprovalLevels
 * on the backend, so edits preview before they are saved.
 */
export function computePmApprovalLevels(ratiosPct, aum, riskCapital) {
  const usable = Number(aum) > 0 && Number(riskCapital) > 0;
  return ratiosPct.map((ratio) => (usable && Number.isFinite(Number(ratio)) ? (((Number(ratio) / 100) * Number(aum)) / Number(riskCapital)) * 100 : null));
}
